/*
 *		Copyright (c) 2011-2020 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .controller('ManageQuotaModalController', ['$scope', '$modalInstance', '$rootScope', 'AccountResource', 'operationComplete',
        function ($scope, $modalInstance, $rootScope, AccountResource, operationComplete) {
            var isPurgePerformed = false;

            $scope.modal = $modalInstance.options;
            _getQuotaConfiguration();

            $scope.updateQuotaNotifications = function () {
                AccountResource.updateQuotaNotification($scope.quotaConfiguration, _operationComplete);
            };

            $scope.updatePurgeProactively = function () {
                AccountResource.updateProactivePurging($scope.quotaConfiguration, _operationComplete);
            };

            $scope.purgeNow = function () {
                AccountResource.purge($scope.quotaConfiguration, function () {
                    _getQuotaConfiguration();
                    $scope.reloadSessionData();

                    isPurgePerformed = true;

                    _operationComplete();
                });
            };

            $scope.ok = $scope.cancel = $scope.close = function () {
                if (isPurgePerformed) {
                    $rootScope.$broadcast('reload.dataTable');
                }

                $modalInstance.dismiss();
            };

            function _getQuotaConfiguration() {
                $scope.modal.loading = true;

                $scope.quotaConfiguration = AccountResource.quotaConfiguration();

                $scope.quotaConfiguration.$promise.finally(function () {
                    $scope.modal.loading = false;
                });
            }

            function _operationComplete() {
                operationComplete('manage_quota_dialog_settings_updated_success_message');
            }
        }
    ]);
